import React from 'react'
import PropTypes from 'prop-types'
import {LineChart, Line} from 'components/Chart'
import isNumber from 'lodash/isNumber'
import NumberFormat from 'components/NumberFormat'
import DayTime from 'components/DayTime'
import {TooltipTable, TooltipRow, TooltipCell} from 'components/Tooltip'

export default class OverviewTableChart extends React.Component {
  static propTypes = {
    data: PropTypes.array,
    today: PropTypes.instanceOf(Date),
    dataKey: PropTypes.string,
    accumulatedValues: PropTypes.bool,
    format: PropTypes.string,
    invertAreaColors: PropTypes.bool
  }

  static contextTypes = {
    containerWidth: PropTypes.number
  }

  constructor(props) {
    super(props)
    this.state = {
      selected: null,
      selectedLine: null
    }
  }

  render() {
    const {data, today, dataKey, invertAreaColors} = this.props
    const {selected, selectedLine} = this.state
    const {containerWidth} = this.context
    if (!containerWidth) return null
    const key = this.getDataKey()

    return (
      <LineChart
        data={data}
        width={containerWidth}
        height={150}
        xAxisKey='date'
        min={0}
        selected={selected}
        today={today}
        margin={{top: 0, left: 0, bottom: 0, right: 0}}
        onSelect={this.onSelect}
        tooltip={this.renderTooltip}
        invertAreaColors={invertAreaColors}
      >
        <Line
          dataKey={`${key}Past`}
          color='lightest'
          strokeWidth='thin'
          selected={selectedLine === `${key}Past` || selectedLine === `${dataKey}SumRegression`}
        />
        <Line dataKey={`${dataKey}SumRegression`} color='awesome-blue' dashed noPoints />
        <Line
          dataKey={key}
          color='awesome-blue'
          area={`${key}Past`}
          selected={selectedLine === key}
        />
      </LineChart>
    )
  }

  renderTooltip = data => {
    const {format} = this.props
    const key = this.getDataKey()

    return (
      <TooltipTable>
        {this.renderDateRow(data)}
        <TooltipRow>
          <TooltipCell><DayTime date={data.datePast} day /></TooltipCell>
          <TooltipCell color='white'><NumberFormat value={data[`${key}Past`]} format={format} /></TooltipCell>
        </TooltipRow>
      </TooltipTable>
    )
  }

  renderDateRow(data) {
    const {format} = this.props
    const key = this.getDataKey()

    if (isNumber(data[key])) {
      return (
        <TooltipRow>
          <TooltipCell><DayTime date={data.date} day /></TooltipCell>
          <TooltipCell color='white'><NumberFormat value={data[key]} format={format} /></TooltipCell>
        </TooltipRow>
      )
    } else {
      return null
    }
  }

  onSelect = (selected, selectedLine) => {
    this.setState({selected, selectedLine})
  }

  getDataKey() {
    const {accumulatedValues, dataKey} = this.props
    return accumulatedValues ? `${dataKey}Sum` : dataKey
  }
}



// WEBPACK FOOTER //
// ./client/components/OverviewTable/OverviewTableChart.js